// extracted by mini-css-extract-plugin
export default {"wrap":"Toast_wrap__jY0IZ","show":"Toast_show__1AmWw","success":"Toast_success__jb702","error":"Toast_error__lxJ0D","dot":"Toast_dot__-K6lk"};